module.exports = __webpack_public_path__ + "img/avatar-8.11ebf16c.png";